<div class="layout-default">
    <div #Column1 style="flex-basis: 30%; display: flex; flex-direction: column;">
        <div style="background-color: #1E88E5; flex: 1;"></div>
        <pm-thumb [ItemOrientation]="'Vertical'"
                  [Mode]="'Basis'" 
                  [ElementFlexBasis]="Row1"
                  [ElementLocation]="'Next'"></pm-thumb>
        <div #Row1 style="background-color: #1EE56A; flex-basis: 30%;"></div>
    </div>
    <pm-thumb [ItemOrientation]="'Horizontal'"
              [Mode]="'Basis'"
              [ElementFlexBasis]="Column1">
    </pm-thumb>
    <div style="background-color: #ff5252; flex: 1;"></div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-14.html